<template>
  <v-snackbar
      :timeout="timeout"
      :color="color"
      v-model="showNotification"
    >
      {{ text }}
      <v-btn dark text @click.native="showNotification = false">Close</v-btn>
    </v-snackbar>
</template>

<script>
import { mapActions } from 'vuex'
import { mapFields } from '@/vueHelpers/vuex'

export default {
  computed: {
    ...mapFields('notifications', [
      'timeout',
      'color',
      'showNotification',
      'text'
    ])
  },
  methods: {
    ...mapActions('notifications', [
      'clearNotification'
    ])
  },
  watch: {
    showNotification (show) {
      if (!show) {
        this.clearNotification()
      }
    }
  }
}
</script>

<style>

</style>
